// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  SceneNodeType,
} from "./types";


export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  assetId: __t.u64().name("asset_id"),
  canonicalId: __t.u64().name("canonical_id"),
  nodePath: __t.string().name("node_path"),
  name: __t.string(),
  translateX: __t.f64().name("translate_x"),
  translateY: __t.f64().name("translate_y"),
  translateZ: __t.f64().name("translate_z"),
  rotateX: __t.f64().name("rotate_x"),
  rotateY: __t.f64().name("rotate_y"),
  rotateZ: __t.f64().name("rotate_z"),
  rotateW: __t.f64().name("rotate_w"),
  scaleX: __t.f64().name("scale_x"),
  scaleY: __t.f64().name("scale_y"),
  scaleZ: __t.f64().name("scale_z"),
  get nodeType() {
    return SceneNodeType.name("node_type");
  },
  meshTriangleCount: __t.option(__t.u32()).name("mesh_triangle_count"),
  sourceRenditionId: __t.u64().name("source_rendition_id"),
});
